import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonItem,
} from "@ionic/react";

import CSS from "csstype";

const MyAccount: React.FC = () => {
  const iframeStyles: CSS.Properties = {
    border: 0,
    height: "100%",
    width: "100%",
  };

  return (
    <IonPage>
      <IonHeader></IonHeader>
      <IonContent fullscreen>
        <iframe
          style={iframeStyles}
          src="https://www.huronpokerleague.com/video-call/"
          allow="camera https://huronpokerleague.com; microphone https://huronpokerleague.com"
          scrolling="yes"
        ></iframe>
      </IonContent>
    </IonPage>
  )
};

export default MyAccount;
